import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import * as api from "./api";
import type { GrandPrizeSaveInput } from "./api";

const listKey = ["portal", "grand-prize"] as const;

export const useGrandPrizes = () =>
  useQuery({ queryKey: listKey, queryFn: api.listGrandPrizes });

export function useGrandPrizeMutations() {
  const client = useQueryClient();
  const invalidate = () => client.invalidateQueries({ queryKey: listKey });
  return {
    create: useMutation({
      mutationFn: (input: GrandPrizeSaveInput) => api.createGrandPrize(input),
      onSuccess: invalidate,
    }),
    edit: useMutation({
      mutationFn: ({ id, input }: { id: string; input: GrandPrizeSaveInput }) =>
        api.editGrandPrize(id, input),
      onSuccess: invalidate,
    }),
  };
}
